import BaseResource, { PagedContentNegotiator } from './index'
import LapTimeResource from '../resources/laptime'
import TeamResource from '../resources/team'

export default class BoardResource extends BaseResource {
    static endpoint = '/boards'

    async getResults(filterOps = {}) {
        if (this.attributes.calculation === 'POINTS') {
            const filters = Object.assign({ board: this.id, approved: true, page_size: 15 }, filterOps)
            return await TeamResource.filter(filters)
        } else {
            const result = await this.wrap('/results').get({ params: filterOps })
            return new PagedContentNegotiator(LapTimeResource, result)
        }
    }

    get cashTournament() {
        return this.attributes.cash_tournament || null
    }

    async getUpcomingRaces(limit = 3) {
        if (this.attributes.calculation !== 'POINTS') {
            return []
        }
        // circular import
        const RankedRaceResource = require('./rankedrace').default
        const result = await RankedRaceResource.filter({ board: this.id, ordering: 'date_time', page_size: 20 })
        const now = new Date()
        return (result.resources || []).filter((race) => race.dateTime && race.dateTime > now).slice(0, limit)
    }

    async joinCashTournament() {
        const result = await this.wrap('/lucra/entries').post()
        return result.data
    }

    toString() {
        return this.attributes.name
    }
}
